module.exports = __webpack_public_path__ + "static/media/breland-cover.70acc47b.png";